// extracted by mini-css-extract-plugin
export default {"main":"TipoCodigoPromocionalSelector_main__ccmuO"};